import SuccessRoundImage from '../../assets/images/success-round.webp';
import useTranslation from '../../localization/i18n.context';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import SuccessFeedbackScreen from '../../components/shared/SuccessFeedbackScreen/SuccessFeedbackScreen';
import { useEffect } from 'preact/hooks';
import { TrackingEvent } from '../../sdk/tracking.event';
import NavigationUtils from '../../utils/navigation.utils';

const ActivationProcess = {
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC',
};

const QueryParams = {
  ACTIVATION: 'activation',
};

export default function CardActivationSuccessPage() {
  const { t } = useTranslation();
  const activationProcess = NavigationUtils.getQueryParam(
    QueryParams.ACTIVATION,
  );

  const closeWebview = () => {
    CloseWebviewEvent.finishSuccessfully();
  };

  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.ACTIVATION_IN_PROGRESS_SCREEN_SHOW,
      TrackingEvent.Sources.CAAS,
    );
  }, []);

  const text =
    activationProcess === ActivationProcess.MANUAL
      ? 'Stay tuned. Activation can take up to 72hs.'
      : 'Stay tuned - we typically process activations in 30 minutes or less';

  return (
    <SuccessFeedbackScreen
      onCloseClick={closeWebview}
      image={SuccessRoundImage}
      title={t('Activation in progress!')}
      text={t(text)}
      subtitle={t(
        "We'll send you an SMS and push notification to set your PIN when your card is ready",
      )}
      ctaAction={closeWebview}
      ctaText={t('Start shopping')}
    />
  );
}
